<template>
  <form v-if="!isLoading" novalidate @submit.prevent="updatePricedLTRSService">
    <div class="columns onboarding-priced-services-view--form">
      <div class="column is-10">
        <h4 class="onboarding-priced-services-view--h2">{{ serviceName }}</h4>
        <p class="onboarding-priced-services-view--price">
          {{ selectedService.price.price | currency }} <span> per service </span
          ><span v-if="str_id === 'fertilization'"> (8 service package)</span>
        </p>
        <LsRadios
          v-model="start_date"
          label="When would you like to start?"
          track-id="onboarding_priced_services_view-start_date"
          name="start_date"
          :options="startDateOptions"
        />
        <div class="onboarding-priced-services-view--charge-info">
          <p>
            Your {{ serviceName }} will occur within a three week window starting on the Monday you
            select. We’re unable to offer call-aheads or advance notice of your
            {{ serviceName }} service.
            <span v-if="str_id === 'fertilization'"
              >Each service will be scheduled about 4-6 weeks apart and you can check your app for
              the next service window.</span
            >
          </p>
          <p>As always, your card is never charged until after the service is completed.</p>
        </div>
      </div>
      <div class="column">
        <LsButton
          text="remove service"
          track-id="onboarding_priced_services_view-remove_service"
          :disabled="onboarding.loadingStatus.isUpdating"
          bg-color="primary-light"
          text-color="primary"
          @click="removeService"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <LsButton
          text="save & continue"
          track-id="onboarding_priced_services_view-save_and_continue"
          :loading="onboarding.loadingStatus.isUpdating"
          type="submit"
          test-id="save_and_continue"
        />
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { LsButton, LsRadios } from '@/components/common';
import {
  ONBOARDING__UPDATE_PRICED_LTRS_SERVICE,
  ONBOARDING__SELECTED_SERVICE,
} from '@/store/types';
import { lsModalService, lsRouterHelpers } from 'ls-vue-common';
import _ from 'lodash';
import { lsOrderServicesHelpers } from '@/helpers';
import { RemoveServiceModal } from '@/modals';

export default {
  name: 'OnboardingPricedServicesView',
  components: {
    LsButton,
    LsRadios,
  },
  data() {
    return {
      start_date: '',
      str_id: lsRouterHelpers.getParam(this.$route, 'str_id'),
    };
  },
  computed: {
    isLoading() {
      return _.isNil(this.selectedService);
    },
    ...mapState(['onboarding']),
    ...mapGetters([ONBOARDING__SELECTED_SERVICE]),
    selectedService() {
      return this[ONBOARDING__SELECTED_SERVICE](this.str_id);
    },
    serviceName() {
      return (
        _.get(this.selectedService, 'price.service.name') ||
        _.get(this.selectedService, 'service.name')
      );
    },
  },
  created() {
    this.generateStartDateOptions();
  },
  methods: {
    ...mapActions([ONBOARDING__UPDATE_PRICED_LTRS_SERVICE]),
    updatePricedLTRSService() {
      this[ONBOARDING__UPDATE_PRICED_LTRS_SERVICE]({
        goToNextStep: true,
        start_date: this.start_date,
        selectedService: this.selectedService,
      });
    },
    generateStartDateOptions() {
      this.startDateOptions = lsOrderServicesHelpers.generateLtrsStartDateOptions();
      this.start_date = _.get(this.selectedService, 'start_date') || this.startDateOptions[0].value;
    },
    removeService() {
      lsModalService.open({
        parent: this,
        component: RemoveServiceModal,
        props: { orderserviceId: this.selectedService.orderservice_id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.onboarding-priced-services-view--form {
  border-bottom: 1px solid $primary-light;
  padding-bottom: 35px;
  margin-bottom: 35px;
}

.onboarding-priced-services-view--h2 {
  font-weight: bold;
}

.onboarding-priced-services-view--price {
  font-size: $size-4;
  color: $primary;
  margin-bottom: 30px;
}

.onboarding-priced-services-view--charge-info {
  background-color: $primary-light;
  width: 448px;
  padding: 23px;
  margin-top: 23px;
  p {
    font-style: italic;
  }
  p:last-child {
    margin-top: 17px;
    font-weight: bold;
  }
}

@media (max-width: $mobile-max-width) {
  .onboarding-priced-services-view--charge-info {
    width: 100%;
  }
}
.themed-app {
  .onboarding-priced-services-view--form {
    border-color: $theme-color-primary-light;
  }
  .onboarding-priced-services-view--price {
    font-size: $theme-txt-body-lg;
    color: $theme-color-primary;
  }

  .onboarding-priced-services-view--charge-info {
    background-color: $theme-color-primary-light;
  }
}
</style>
